import moment from "moment";
import { formatPrice } from "../../../common/formatPrice";
export function GET_REPORTS_REQUEST(state) {
  state;
  state.reports = {
    ...state.reports,
    isLoading: true
  };
}
export function GET_REPORTS_SUCCESS(state, payload) {
  let data = [];
  const { orders, meta } = payload.data.data;
  orders.map(item => {
    let branchCodeData, paymentTerm;
    if (item.paymentTerm === "BT") {
      paymentTerm = "Bank Transfer";
    } else if (
      item.paymentTerm === "OD-GIRO" ||
      item.paymentTerm === "OD-CASH" ||
      item.paymentTerm === "OD"
    ) {
      paymentTerm = "COD";
    } else if (
      item.paymentTerm === "CR-GIRO" ||
      item.paymentTerm === "CR-CASH" ||
      item.paymentTerm === "CR"
    ) {
      paymentTerm = "TOP";
    } else if (item.paymentTerm === 'PG') {
      paymentTerm = "Payment Gateway";
    }
    if (item.branchCodeData) {
      branchCodeData = item.branchCodeData.branch;
    }
    data.push({
      branchCodeData: branchCodeData || "-",
      orderId: item.orderId || "-",
      oracleCustomerId: item.oracleCustomerId || "-",
      status: item.orderStatus || "-",
      paymentStatus: item.payment ? item.payment.status : "-",
      customerName: item.user.customerName || "-",
      customerId: item.user.customerId || "-",
      paymentMethod: paymentTerm || "-",
      totalValue: formatPrice(item.total) || "-",
      created: moment(item.createdAt).format("DD-MM-YYYY HH:mm:ss") || "-",
      updated: moment(item.updatedAt).format("DD-MM-YYYY HH:mm:ss") || "-"
    });
    return item;
  });
  state;
  state.reports = {
    data: data,
    count: meta.total_data,
    status: payload.data.data.status,
    isLoading: false
  };
}
export function GET_REPORTS_ERROR(state, payload) {
  state;
  state.reports = {
    isLoading: false,
    error: true,
    errorMessage: payload
  };
}

export function GET_EXPORT_TO_EXCEL_REPORT_REQUEST(state) {
  state;
  state.exportReport = {
    ...state.exportReport,
    isLoading: true
  };
}
export function GET_EXPORT_TO_EXCEL_REPORT_SUCCESS(state, payload) {
  state;
  state.exportReport = {
    data: payload.data.data.message,
    status: payload.data.data.status,
    isLoading: false
  };
}
export function GET_EXPORT_TO_EXCEL_REPORT_ERROR(state, payload) {
  state;
  state.exportReport = {
    isLoading: false,
    error: true,
    errorMessage: payload
  };
}